import { IonToolbar } from "@ionic/react";
import { forwardRef } from "react";
import { cx } from "@/lib/style/cva.config";

export const Toolbar = forwardRef<HTMLIonToolbarElement, React.ComponentProps<typeof IonToolbar>>(
  function Toolbar(props, ref) {
    return (
      <IonToolbar
        ref={ref}
        {...props}
        className={cx(
          "ion-no-border ion-px-4 ion-py-3 ion-min-h-16 plt-desktop:sm:ion-px-[max(calc(calc(100vw-640px)/2),theme(spacing.4))]",
          props.className,
        )}
      >
        {props.children}
      </IonToolbar>
    );
  },
);
